module.exports = __webpack_public_path__ + "img/silene.6d805722.jpg";